import LocalStorage from 'Core/commons/LocalStorage';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapStateSystem } = createNamespacedHelpers('system')

export default {
    data() {
        return {
            fields: [],
            namespaceLocalStorage: null
        }
    },
    computed: {
        ...mapStateSystem([
            'reCaptchav3'
        ]),
        /**
         * Return, if exist, the name of previous step route
         *
         * @returns {(string | false)}
         */
        previousStep() {
            return this.$route.meta.previous || false
        },

        /**
         * Return, if exist, the name of next step route
         *
         * @returns {(string | false)}
         */
        nextStep() {
            return this.$route.meta.next || false
        },

        /**
         * Return the nuber of the current step
         * 
         * @returns {number}
         */
        currentStepNumber() {
            return Number(this.$route.path.slice(-1))
        },

        /**
         * Check if the user can click on the button 
         * 
         * @returns {boolean}
         */
        isDisabledNextStep() {
            const isValidForm = !!this.fields.length && this.fields.every(field => field.validateState === 'success');
            for(var i = 0; i< this.fields.length; i++){
                if(this.fields[i].initialValue){
                    this.fields[i].validateState = "success";
                }
            }
            return !isValidForm;
        },
        /**
         * Return the local storage of the steps form
         *
         * @return {object}
         */
        localStorage() {
            return new LocalStorage(this.namespaceLocalStorage, 'form');
        },
        /**
         * Return the local storage of the steps form
         *
         * @return {object}
         */
        stepperStorage() {
            return new LocalStorage(this.namespaceLocalStorage, 'stepper');
        },
        /**
         * Return the local storage of the language interface
         *
         * @return {object}
         */
         langStorage() {
            return new LocalStorage(this.namespaceLocalStorage, 'lang');
        },
        /**
         * Return the interface language find in query param
         * @returns {string}
         */
        currentLang() {
            return this.$route.query.lang;
        }
    },
    methods: {
        /**
         * Initialisation for steps
         * - init fields prop, needed to check isDisabledNextStep
         * - if user has already entered data, start validation of the form (in case where you navigate between step)
         * 
         * @return {void}
         */
        initStep() {
            this.updateCurrentStepInStorage()
            this.initialiseStore(this.localStorage.get());
            this.fields = this.$refs.form.fields;
             setTimeout(() => {   
                const hasAlreadyValues = !!this.fields.flatMap(f => f.fieldValue).every(f => !!f);
                if(hasAlreadyValues) this.$refs.form.validate();
            });
        },
        /**
         * Persist state of form pass in param in local storage
         * to retrieve the state if we reload the page
         *
         * @param {*} form to persit
         */
        persistStateInLocalStorage(form) {
            const localStorage = this.localStorage;
            localStorage.set({...localStorage.get(), ...form});
        },
        /**
         * Create local storage of the state of the steps form
         */
        createStateInLocalStorage() {
            if(!this.localStorage.get()) this.localStorage.set({});
        },
        /**
         * Destroy local storage of the state of the steps form
         */
        destroyStateInLocalStorage() {
            this.localStorage.delete()
        },
        /**
         * Persist current step number in storage  
         * Used to control if user don't skip step
         */
        updateCurrentStepInStorage() {
            this.stepperStorage.set({currentStep: this.currentStepNumber})
        },
        /**
         * Destroy local storage of the current step number
         */
         destroyStepperInLocalStorage() {
            this.stepperStorage.delete()
        },
        /**
         * Persist current lang interface in storage  
         * Used to fill lang after google signup redirection
         */
         updateCurrentLangInStorage(lang) {
            this.langStorage.set({lang})
        },
        /**
         * Destroy local storage of the current lang interface
         */
         destroyLangInLocalStorage() {
            this.langStorage.delete()
        },
        /**
         * if is enabled, return token of reCAPTCHA v3
         * - first Wait until recaptcha has been loaded.
         * - then Execute reCAPTCHA with action passed as param and return them
         * else return a string notBlank for pass validator back
         */
        async getTokenReCaptchaV3(action) {
            if (this.reCaptchav3.isEnabled) {
                await this.$recaptchaLoaded()
                return await this.$recaptcha(action)
            } else {
                return 'undefined'
            }
        }
    }
}
